import { makeStyles } from '@material-ui/core/styles';

export const useCancelPurchaseStyles = makeStyles(() => ({
  container: {
    borderTop: (props) => (props.mobile ? '' : '1px solid #6A148E'),
    backgroundColor: (props) => (props.mobile ? '' : '#F1F1F1'),
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px',
    width: '100%',
    padding: (props) => (props.mobile ? '' : '30px 70px'),
  },
  button: {
    maxWidth: 200,
    margin: '0 auto',
  },
}));

export const useCancelPurchaseFormStyles = makeStyles(() => ({
  message: {
    marginTop: 28,
  },
}));
